module.exports = __webpack_public_path__ + "img/image-thumb-14.b7ad317f.webp";